export default "__VITE_ASSET__BQs9gfSE__"